import { render, staticRenderFns } from "./CbsAppNavbarVerticalLayout.vue?vue&type=template&id=21209a78"
import script from "./CbsAppNavbarVerticalLayout.vue?vue&type=script&lang=js"
export * from "./CbsAppNavbarVerticalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports